/* Hai · fondo que respira (2-oct-2026; lluvia y partículas sumadas el mismo día)
   Dos capas detrás de todas las secciones, primeras hijas de .theme-content con z-index -1 (ese
   envoltorio de Avante es relative, z-index 1 y crema: se pintan sobre su crema y debajo de todo
   el contenido):
   - El cielo (.hai-respira), fijo a la pantalla: tres auras de marca que respiran (CSS: inhala 4 s,
     exhala 6 s) y una red de partículas en un canvas que respira con ellas (al inhalar se enlazan a
     más distancia) y se borra donde hay texto.
   - La página (.hai-respira__pagina), en coordenadas de la página: las piezas del dibujo de Hai
     (ondas de la etiqueta, arco, anillo, disco, puntos que suben) y la lluvia (una gota que abre
     anillos). Van pegadas al contenido: el hueco donde nacen sigue siendo su lugar al desplazar. En
     el teléfono los huecos son franjas entre bloques; fijas a la pantalla, el contenido las tapaba
     apenas uno se movía. Y así nunca les pasa texto por encima.
   Para que se vean, los fondos crema de las secciones se vuelven transparentes (la base es el mismo
   crema) y las franjas azul pálido quedan al 60 %; tarjetas, celdas, fotos y botones conservan su
   fondo y tapan las capas solos. Con "reducir movimiento" quedan solo las auras quietas. Si algo
   falla, las secciones siguen opacas y nada se ve. */
(() => {
  'use strict';
  const cielo = document.querySelector('.hai-respira');
  if (!cielo) return;
  const quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const SVG = 'http://www.w3.org/2000/svg';

  // Intensidad: el ajuste del editor, o ?respira=muy-sutil|sutil|visible para comparar.
  // cada/max/a: piezas · lluvia/aLluvia: cada cuánto cae una gota y su opacidad · red: partículas
  const NIVELES = {
    'muy-sutil': { cada: [4200, 6200], max: 3, a: 0.22, lluvia: [3800, 5800], aLluvia: 0.3, red: 0.65 },
    'sutil': { cada: [2800, 4200], max: 5, a: 0.34, lluvia: [2400, 4000], aLluvia: 0.42, red: 1 },
    'visible': { cada: [1800, 2800], max: 7, a: 0.5, lluvia: [1500, 2600], aLluvia: 0.58, red: 1.4 }
  };
  let pedido = cielo.dataset.nivel;
  try { pedido = new URLSearchParams(location.search).get('respira') || pedido; } catch (e) { /* sin URL */ }
  if (!NIVELES[pedido]) pedido = 'sutil';
  const nivel = NIVELES[pedido];
  cielo.dataset.nivel = pedido;

  const hogar = document.querySelector('.theme-content') || document.body;
  if (hogar.firstElementChild !== cielo) hogar.prepend(cielo);

  // Todo lo demás arranca cuando la página terminó de cargar y el navegador está libre, para no
  // competir con la carga (medido el 2-oct-2026: arrancar junto con la página sumaba ~1,2 s de
  // tareas largas a la carga de la home con el procesador frenado × 4). El cielo aparece con un
  // fundido (CSS: .hai-respira--viva). Si el script falla, el cielo queda invisible y las
  // secciones, opacas: la página se ve como antes.
  const libre = f => (window.requestIdleCallback ? window.requestIdleCallback(f, { timeout: 2500 }) : setTimeout(f, 300));
  const enMarcha = () => libre(arrancar);
  if (document.readyState === 'complete') enMarcha();
  else window.addEventListener('load', enMarcha, { once: true });

  function arrancar() {
    cielo.classList.add('hai-respira--viva');
    // 1. Fondos de sección
    const CREMA = 'rgb(253, 253, 249)';
    const PALIDO = 'rgb(237, 247, 255)';
    const PALIDO_ALFA = 0.6;
    const PALIDO_T = 'rgba(237, 247, 255, ' + PALIDO_ALFA + ')';
    const MEDIOS = '.media, figure, picture, img, video, [class*="gallery"], .product__media-wrapper, .card, product-card';
    const alfa = color => {
      if (!color || color === 'transparent') return 0;
      const m = color.match(/rgba?\(([^)]+)\)/);
      if (!m) return 1;
      const p = m[1].split(/[\s,/]+/).filter(Boolean).map(Number);
      return p.length > 3 ? p[3] : 1;
    };
    // Las franjas que quedaron translúcidas y cuánto tapan a cada altura (0 arriba, 1 abajo)
    const bandas = new Map();
    // Un degradé vertical de marca, azul pálido y crema (como el de las reseñas de la home): el mismo
    // dibujo con el azul translúcido y el crema transparente, y su opacidad por altura. Así no queda
    // una costura con la franja vecina, que ya es translúcida.
    function degradeDeMarca(img) {
      if (!img.startsWith('linear-gradient(') || img.split('gradient(').length !== 2 || img.includes('url(')) return null;
      const cuerpo = img.slice(16, -1).trim();
      if (!cuerpo.startsWith('rgb') && !/^(to bottom|180deg),/.test(cuerpo)) return null;
      const paradas = [...cuerpo.matchAll(/(rgba?\([^)]+\))(?:\s+([\d.]+)%)?/g)].map(p => ({ c: p[1], pos: p[2] == null ? null : Number(p[2]) / 100 }));
      if (paradas.length < 2 || !paradas.every(p => p.c === PALIDO || p.c === CREMA)) return null;
      paradas.forEach((p, i) => {
        if (p.pos != null) return;
        if (i === 0) p.pos = 0;
        else if (i === paradas.length - 1) p.pos = 1;
        else p.pos = (paradas[i - 1].pos + (paradas.slice(i + 1).find(q => q.pos != null) || { pos: 1 }).pos) / 2;
      });
      const a = p => (p.c === PALIDO ? PALIDO_ALFA : 0);
      return {
        css: 'linear-gradient(' + paradas.map(p => (p.c === PALIDO ? PALIDO_T : 'rgba(253, 253, 249, 0)') + ' ' + (p.pos * 100).toFixed(1) + '%').join(', ') + ')',
        alfa: t => {
          if (t <= paradas[0].pos) return a(paradas[0]);
          for (let i = 1; i < paradas.length; i++) {
            const p = paradas[i - 1], q = paradas[i];
            if (t <= q.pos) return q.pos > p.pos ? a(p) + ((a(q) - a(p)) * (t - p.pos)) / (q.pos - p.pos) : a(q);
          }
          return a(paradas[paradas.length - 1]);
        }
      };
    }
    // En dos pasadas: primero solo se lee, por tramos de 8 ms (sin tareas largas), y al final se
    // escribe todo junto: leer y escribir intercalado obligaba a recalcular estilos una y otra vez.
    function aclarar(base, listo) {
      const ancho = document.documentElement.clientWidth * 0.9;
      const raiz = base || document.querySelector('.inside-content main') || document.querySelector('main');
      if (!raiz) { if (listo) listo(); return; }
      const nodos = [raiz, ...raiz.querySelectorAll('*')];
      const cambios = [];
      let i = 0;
      const tramo = () => {
        const fin = performance.now() + 8;
        while (i < nodos.length && performance.now() < fin) {
          const el = nodos[i++];
          if (el.offsetWidth < ancho || bandas.has(el)) continue;
          const cs = getComputedStyle(el);
          const bg = cs.backgroundColor, img = cs.backgroundImage;
          const degrade = img !== 'none' && (bg === CREMA || bg === PALIDO || alfa(bg) === 0) ? degradeDeMarca(img) : null;
          if (bg !== CREMA && bg !== PALIDO && !degrade) continue;
          if (img !== 'none' && !degrade) continue;
          if (cs.position === 'fixed' || cs.position === 'sticky') continue;
          if (parseFloat(cs.borderTopLeftRadius) > 0 || cs.boxShadow !== 'none' || parseFloat(cs.borderTopWidth) > 0) continue;
          if (el.closest(MEDIOS)) continue;
          cambios.push({ el, bg, degrade });
        }
        if (i < nodos.length) { setTimeout(tramo, 0); return; }
        for (const { el, bg, degrade } of cambios) {
          const perfiles = [];
          if (degrade) {
            el.style.setProperty('background-image', degrade.css, 'important');
            perfiles.push(degrade.alfa);
          }
          if (bg === CREMA) el.style.setProperty('background-color', 'transparent', 'important');
          else if (bg === PALIDO) {
            el.style.setProperty('background-color', PALIDO_T, 'important');
            perfiles.push(() => PALIDO_ALFA);
          }
          if (perfiles.length) bandas.set(el, t => 1 - perfiles.reduce((p, g) => p * (1 - g(t)), 1));
        }
        if (listo) listo();
      };
      tramo();
    }
    const aclarado = new Promise(listo => aclarar(null, listo));
    document.addEventListener('shopify:section:load', ev => aclarar(ev.target));

    // 2. Auras
    const auras = document.createElement('div');
    auras.className = 'hai-respira__auras';
    auras.innerHTML = '<i class="hai-respira__aura hai-respira__aura--a"></i><i class="hai-respira__aura hai-respira__aura--b"></i><i class="hai-respira__aura hai-respira__aura--c"></i>';
    cielo.appendChild(auras);
    const inicio = performance.now();
    if (quieto) return;

    const pagina = document.createElement('div');
    pagina.className = 'hai-respira__pagina';
    pagina.setAttribute('aria-hidden', 'true');
    cielo.after(pagina);

    // ---- Utilidades compartidas ----
    function techo() {
      let b = 0;
      document.querySelectorAll('sticky-header, .shopify-section-header, .shopify-section-mobile-header').forEach(h => {
        const r = h.getBoundingClientRect();
        if (r.height > 0 && r.top < 40) b = Math.max(b, r.bottom);
      });
      return b;
    }
    function cajonAbierto() {
      const b = document.body;
      return b.classList.contains('hidden') || b.classList.contains('overflow-hidden') ||
        document.documentElement.classList.contains('overflow-hidden');
    }
    // Bajo una franja translúcida lo del fondo se ve más débil: se compensa, con tope
    const compensar = (a, pasa) => Math.min(a * 2.2, a / Math.max(0.25, pasa));

    // La posición de desplazamiento se guarda al desplazar: leerla en cada cuadro obligaba al
    // navegador a recalcular estilos a destiempo.
    let sx = window.scrollX, sy = window.scrollY, movido = 0;
    window.addEventListener('scroll', () => { sx = window.scrollX; sy = window.scrollY; movido = performance.now(); }, { passive: true });

    // Qué hay delante de un punto del fondo: texto (ahí no: estorba la lectura), algo que lo tapa
    // (tarjeta, foto, botón: queda detrás, como corresponde a un fondo) o nada. En lo libre dice
    // también cuánto deja pasar lo que lo cubre (una franja al 60 % deja pasar el 40 %).
    // Preguntarle al navegador qué hay en un punto (elementFromPoint) es lo más caro de todo el
    // fondo: con el procesador de un teléfono de gama media, las búsquedas de la primera versión
    // dejaban la home ocupada el 97 % del tiempo. Por eso se pregunta en pocos puntos, lo ya visto se
    // recuerda por elemento (memo), se deja de buscar en cuanto un lugar no puede servir y no se
    // busca mientras la página se desplaza ni otra vez en la misma vista donde no hubo lugar.
    const TEXTO = 'p, h1, h2, h3, h4, h5, h6, li, dt, dd, label, a, button, td, th, blockquote, summary, ' +
      'input, select, textarea, .rte, .price, [class*="title"], [class*="heading"]';
    const TAPA = 'img, picture, video, iframe, canvas, svg, .card, product-card, .media';
    function clasificar(el) {
      // Primero lo que tapa: un título dentro de una tarjeta queda tapado por la tarjeta, no estorba
      if (el.closest(TAPA)) return { tipo: 'tapado' };
      if (el.closest(TEXTO)) return { tipo: 'texto' };
      for (const n of el.childNodes) if (n.nodeType === 3 && n.textContent.trim()) return { tipo: 'texto' };
      // Libre: lo que deja pasar el camino hasta .theme-content (las franjas, según la altura)
      let fijo = 1;
      const franjas = [];
      for (let n = el; n && n !== document.body && n !== hogar; n = n.parentElement) {
        if (bandas.has(n)) { franjas.push(n); continue; }
        const cs = getComputedStyle(n);
        if (cs.backgroundImage !== 'none') return { tipo: 'tapado' };
        const a = alfa(cs.backgroundColor);
        if (a >= 0.95) return { tipo: 'tapado' };
        fijo *= 1 - a;
      }
      return { tipo: 'libre', fijo, franjas };
    }
    function delante(x, y, memo) {
      const el = document.elementFromPoint(x, y);
      if (!el || el === document.documentElement || el === document.body) return { tipo: 'libre', pasa: 1 };
      let c = memo.el.get(el);
      if (!c) { c = clasificar(el); memo.el.set(el, c); }
      if (c.tipo !== 'libre') return c;
      let pasa = c.fijo;
      for (const f of c.franjas) {
        let r = memo.rect.get(f);
        if (!r) { r = f.getBoundingClientRect(); memo.rect.set(f, r); }
        pasa *= 1 - bandas.get(f)(r.height ? (y - r.top) / r.height : 0);
      }
      return { tipo: 'libre', pasa };
    }
    // Un lugar en la pantalla: sin texto delante en ningún punto de una grilla de 4 × 3 ni en un
    // anillo de 12 px alrededor (que no rocen las letras), con al menos la mitad a la vista (en el
    // teléfono, el 40 %: los huecos son angostos y asomar detrás de una tarjeta también es fondo) y
    // que cumpla `lejos` (en coordenadas de la página). Devuelve la posición en la página y cuánto
    // deja pasar, en promedio, lo que lo cubre.
    const MARGEN = 12;
    function rozaTexto(x, y, w, h, W, H, memo) {
      const xs = [x - MARGEN, x + w / 2, x + w + MARGEN], ys = [y - MARGEN, y + h / 2, y + h + MARGEN];
      for (const px of xs) for (const py of ys) {
        if ((px === xs[1] && py === ys[1]) || px < 0 || py < 0 || px > W || py > H) continue;
        if (delante(px, py, memo).tipo === 'texto') return true;
      }
      return false;
    }
    function lugar(w, h, lejos) {
      const W = document.documentElement.clientWidth, H = window.innerHeight, arriba = techo() + 16;
      const escritorio = W >= 990, minimo = Math.ceil((W < 750 ? 0.4 : 0.5) * 12);
      const origen = pagina.getBoundingClientRect();
      const memo = { el: new Map(), rect: new Map() };
      for (let i = 0; i < 12; i++) {
        // En escritorio, más seguido en los costados: el centro suele estar ocupado por el contenido
        let x;
        if (escritorio && Math.random() < 0.6) x = Math.random() < 0.5 ? Math.random() * W * 0.2 : W * 0.8 + Math.random() * W * 0.2 - w;
        else x = Math.random() * (W - w);
        x = Math.max(0, Math.min(W - w, x));
        const y = arriba + Math.random() * Math.max(10, H - arriba - h - 12);
        const cx = x + w / 2 - origen.left, cy = y + h / 2 - origen.top;
        if (!lejos(cx, cy)) continue;
        let texto = false, libres = 0, pasa = 0;
        for (let k = 0; k < 12 && !texto; k++) {
          // Si ya no puede llegar al mínimo de puntos a la vista, no sigue preguntando
          if (libres + (12 - k) < minimo) break;
          const d = delante(x + (w * ((k % 4) + 0.5)) / 4, y + (h * (((k / 4) | 0) + 0.5)) / 3, memo);
          if (d.tipo === 'texto') texto = true;
          else if (d.tipo === 'libre') { libres++; pasa += d.pasa; }
        }
        if (texto || libres < minimo || rozaTexto(x, y, w, h, W, H, memo)) continue;
        return { x: x - origen.left, y: y - origen.top, cx, cy, pasa: pasa / libres };
      }
      return null;
    }
    // Un turno cada [a, b] ms. Mientras la página se desplaza no se busca: se espera a que se quede
    // quieta. Donde no hubo lugar no se insiste: se vuelve a probar al desplazar un tercio de
    // pantalla o, si no, después de tres turnos (por si algo cambió: un carrusel, una pestaña).
    function turnos([a, b], accion) {
      let fallo = null;
      const siguiente = ms => setTimeout(turno, ms == null ? a + Math.random() * (b - a) : ms);
      function turno() {
        if (document.hidden || cajonAbierto()) return siguiente();
        if (performance.now() - movido < 300) return siguiente(400);
        if (fallo && Math.abs(sy - fallo.y) < window.innerHeight / 3 && fallo.saltos < 3) {
          fallo.saltos++;
          return siguiente();
        }
        fallo = accion() ? null : { y: sy, saltos: 0 };
        siguiente();
      }
      siguiente();
    }

    // 3a. Piezas
    const svg = (w, h, cuerpo) => '<svg xmlns="' + SVG + '" viewBox="0 0 ' + w + ' ' + h + '" aria-hidden="true">' + cuerpo + '</svg>';
    function ondas() {
      let cuerpo = '';
      for (let i = 0; i < 5; i++) {
        let d = '';
        for (let x = 0; x <= 220; x += 4) {
          const y = 8 + i * 10 + 3 * Math.sin((x / 22) * Math.PI * 2 + i * 0.6);
          d += (x ? ' L' : 'M') + x + ' ' + y.toFixed(1);
        }
        cuerpo += '<path d="' + d + '" stroke-width="1.2"/>';
      }
      return svg(220, 56, cuerpo);
    }
    const PIEZAS = {
      ondas: { w: 240, h: 60, html: ondas },
      arco: { w: 120, h: 120, html: () => svg(100, 100, '<path d="M6 96 A90 90 0 0 1 96 6" stroke-width="2.2"/>') },
      anillo: { w: 160, h: 160, html: () => svg(120, 120, '<circle cx="60" cy="60" r="57" stroke-width="1.4"/>') },
      disco: { w: 170, h: 170, html: () => '<i class="hai-respira__disco"></i>' },
      puntos: { w: 60, h: 100, html: () => [10, 26, 40, 52].map((x, i) => '<i class="hai-respira__punto" style="left:' + x + 'px;--r:' + (i * 1.3).toFixed(1) + 's"></i>').join('') }
    };
    // Una bolsa barajada: todas las piezas salen antes de repetir alguna
    let bolsa = [];
    const siguienteTipo = () => {
      if (!bolsa.length) {
        bolsa = Object.keys(PIEZAS);
        for (let i = bolsa.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [bolsa[i], bolsa[j]] = [bolsa[j], bolsa[i]]; }
      }
      return bolsa.pop();
    };
    const vivas = [];
    // Solo cuentan para el máximo las que están a la vista: las que quedaron arriba al desplazar no
    const aLaVista = v => { const r = v.el.getBoundingClientRect(); return r.bottom > -80 && r.top < window.innerHeight + 80; };
    function brotar() {
      if (vivas.filter(aLaVista).length >= nivel.max) return true;
      const tipo = siguienteTipo();
      const p = PIEZAS[tipo];
      const escala = window.innerWidth < 750 ? 0.8 : 1;
      const w = Math.round(p.w * escala), h = Math.round(p.h * escala);
      const sitio = lugar(w, h, (cx, cy) => vivas.every(v => Math.hypot(v.cx - cx, v.cy - cy) > 200));
      if (!sitio) return false;
      const vida = 11 + Math.random() * 4;
      const el = document.createElement('div');
      el.className = 'hai-respira__pieza hai-respira__pieza--' + tipo;
      el.style.cssText = 'left:' + Math.round(sitio.x) + 'px;top:' + Math.round(sitio.y) + 'px;width:' + w + 'px;height:' + h + 'px;--vida:' + vida.toFixed(1) + 's;--a:' + compensar(nivel.a, sitio.pasa).toFixed(3);
      // La pieza anima su opacidad de 0 a 1 (keyframes fijos: corre en el compositor) y la tinta de
      // adentro pone la opacidad de la intensidad
      el.innerHTML = '<div class="hai-respira__tinta">' + p.html() + '</div>';
      pagina.appendChild(el);
      const viva = { cx: sitio.cx, cy: sitio.cy, el };
      vivas.push(viva);
      setTimeout(() => { el.remove(); vivas.splice(vivas.indexOf(viva), 1); }, vida * 1000 + 200);
      return true;
    }

    // 3b. Lluvia: una gota celeste cae y abre tres anillos que se apagan
    const gotas = [];
    function llover() {
      const movil = window.innerWidth < 750;
      const r = movil ? 40 : 54, caida = movil ? 36 : 56;
      const w = 2 * r + 8, h = Math.round(r * 0.8) + caida + 4;
      const sitio = lugar(w, h, (cx, cy) =>
        vivas.every(v => Math.hypot(v.cx - cx, v.cy - cy) > 120) && gotas.every(g => Math.hypot(g.cx - cx, g.cy - cy) > r * 2.5));
      if (!sitio) return false;
      gotas.push({ cx: sitio.cx, cy: sitio.cy });
      if (gotas.length > 4) gotas.shift();
      const el = document.createElement('div');
      // En el teléfono la gota cae menos (otros keyframes: sin variables adentro corren en el compositor)
      el.className = 'hai-respira__lluvia' + (movil ? ' hai-respira__lluvia--corta' : '');
      el.style.cssText = 'left:' + Math.round(sitio.x) + 'px;top:' + Math.round(sitio.y) + 'px;width:' + w + 'px;height:' + h +
        'px;--a:' + compensar(nivel.aLluvia, sitio.pasa).toFixed(3) + ';--iy:' + (caida + Math.round(r * 0.4)) + 'px';
      el.innerHTML = '<i class="hai-respira__gota"></i>' + [0, 1, 2].map(k =>
        '<i class="hai-respira__onda" style="--d:' + Math.round(2 * r * (1 - k * 0.18)) + 'px;--r:' + (0.48 + k * 0.32).toFixed(2) + 's"></i>').join('');
      pagina.appendChild(el);
      setTimeout(() => el.remove(), 4300);
      return true;
    }

    // Que la página no parta vacía
    // Las primeras piezas y la primera gota, con las secciones ya aclaradas y en su propio turno
    aclarado.then(() => libre(() => {
      brotar();
      setTimeout(brotar, 900);
      turnos(nivel.cada, brotar);
      setTimeout(() => { llover(); turnos(nivel.lluvia, llover); }, 1400);
    }));

    // 4. Red de partículas: puntos que se acercan y se unen y, de vez en cuando, tres que se juntan y
    // se iluminan (tres ingredientes, una fórmula). Respira con las auras: al inhalar se enlazan a
    // más distancia. Un paralaje leve al desplazar la deja más atrás que el contenido. Se borra
    // donde hay texto y se refuerza bajo las franjas translúcidas.
    // La dibuja un worker sobre un OffscreenCanvas: redibujar un lienzo de pantalla completa 30 veces
    // por segundo desde el hilo principal lo dejaba ocupado (medido el 2-oct-2026 con el procesador
    // de un teléfono de gama media: la home quieta pasaba de 39 % a 81 %). Desde el worker, el
    // compositor toma cada cuadro sin pasar por el hilo principal; aquí solo se mide el texto y las
    // franjas cada tanto y se avisa el desplazamiento. Sin worker (navegadores antiguos) no hay red.
    function dibujante(alcance) {
      // Esta función se ejecuta tal cual dentro del worker: no usa nada de afuera, todo llega por
      // mensajes. Los tiempos van en milisegundos de reloj (timeOrigin + now), iguales en los dos hilos.
      const TAU = Math.PI * 2, MG = 30, PARALAJE = 0.15;
      const CELESTE = '143, 205, 255', STEEL = '79, 100, 153';
      let ctx = null, W = 0, H = 0, dpr = 1, red = 1, cero = 0, fps = 30;
      let sx = 0, sy = 0, puntero = null, pausa = false, ultimo = 0;
      let texto = [], bandas = [], nodos = [], triadas = [], proxTriada = 0;
      const reloj = () => performance.timeOrigin + performance.now();
      const nuevoNodo = () => {
        const ang = Math.random() * TAU, v = 5 + Math.random() * 9;
        return { x: Math.random() * W, y: Math.random() * H, vx: Math.cos(ang) * v, vy: Math.sin(ang) * v, r: 1.3 + Math.random() * 1.5, celeste: Math.random() < 0.4 };
      };
      function dimensionar(w, h, d) {
        W = w; H = h; dpr = d;
        ctx.canvas.width = Math.round(W * dpr);
        ctx.canvas.height = Math.round(H * dpr);
        const n = Math.round(Math.max(14, Math.min(46, (W * H) / (W < 750 ? 16000 : 26000))) * Math.min(1.2, red));
        while (nodos.length < n) nodos.push(nuevoNodo());
        nodos.length = n;
        for (const nd of nodos) if (nd.x > W + MG) nd.x = Math.random() * W;
      }
      // Bajo una franja translúcida, más fuerte (cada franja trae su opacidad en 11 alturas)
      const refuerzo = (x, y) => {
        let pasa = 1;
        for (const b of bandas) {
          if (x < b.x || x > b.x + b.w || y < b.y || y > b.y + b.h) continue;
          const i = Math.min(9.999, Math.max(0, (b.h ? (y - b.y) / b.h : 0) * 10)), k = Math.floor(i);
          pasa *= 1 - (b.a[k] + (b.a[k + 1] - b.a[k]) * (i - k));
        }
        return 1 / Math.max(0.4, pasa);
      };
      // Al inhalar sube a 1, al exhalar baja a 0, con el ritmo de las auras (10 s, 40 % inhala)
      const suave = q => 0.5 - 0.5 * Math.cos(Math.PI * q);
      const respiro = ahora => {
        const p = (((ahora - cero) / 10000) % 1 + 1) % 1;
        return p < 0.4 ? suave(p / 0.4) : 1 - suave((p - 0.4) / 0.6);
      };
      const envolvente = e => (e < 800 ? e / 800 : e < 2400 ? 1 : Math.max(0, 1 - (e - 2400) / 1800));
      function dibujar(ahora, dt) {
        const k = respiro(ahora);
        const D = (W < 750 ? 120 : 150) * (0.82 + 0.28 * k);
        const altoV = H + 2 * MG, desp = -sy * PARALAJE;
        for (const nd of nodos) {
          nd.x += nd.vx * dt;
          nd.y += nd.vy * dt;
          if (nd.x < -MG) nd.x = W + MG; else if (nd.x > W + MG) nd.x = -MG;
          if (nd.y < -MG) nd.y = H + MG; else if (nd.y > H + MG) nd.y = -MG;
          nd.px = nd.x;
          nd.py = (((nd.y + desp + MG) % altoV) + altoV) % altoV - MG;
          nd.f = refuerzo(nd.px + sx, nd.py + sy);
        }
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.clearRect(0, 0, W, H);
        // Enlaces
        ctx.lineWidth = 1;
        const aLinea = 0.2 * red * (0.55 + 0.45 * k);
        for (let i = 0; i < nodos.length; i++) {
          const a = nodos[i];
          for (let j = i + 1; j < nodos.length; j++) {
            const b = nodos[j], dx = a.px - b.px, dy = a.py - b.py, d2 = dx * dx + dy * dy;
            if (d2 >= D * D) continue;
            ctx.strokeStyle = 'rgba(' + STEEL + ',' + (aLinea * (1 - Math.sqrt(d2) / D) * Math.min(a.f, b.f)).toFixed(3) + ')';
            ctx.beginPath(); ctx.moveTo(a.px, a.py); ctx.lineTo(b.px, b.py); ctx.stroke();
          }
        }
        // El puntero se engancha a los puntos cercanos (solo con mouse)
        if (puntero) {
          const R = 160;
          for (const nd of nodos) {
            const d = Math.hypot(nd.px - puntero.x, nd.py - puntero.y);
            if (d >= R) continue;
            ctx.strokeStyle = 'rgba(' + STEEL + ',' + (0.2 * red * (1 - d / R) * nd.f).toFixed(3) + ')';
            ctx.beginPath(); ctx.moveTo(nd.px, nd.py); ctx.lineTo(puntero.x, puntero.y); ctx.stroke();
          }
        }
        // Tres que se juntan: la fórmula
        if (ahora >= proxTriada) {
          proxTriada = ahora + (7000 + Math.random() * 4000) / red;
          for (let intento = 0; intento < 10; intento++) {
            const a = nodos[(Math.random() * nodos.length) | 0];
            const cerca = nodos.filter(b => b !== a && Math.hypot(a.px - b.px, a.py - b.py) < D)
              .sort((p, q) => Math.hypot(a.px - p.px, a.py - p.py) - Math.hypot(a.px - q.px, a.py - q.py));
            if (cerca.length >= 2 && Math.hypot(cerca[0].px - cerca[1].px, cerca[0].py - cerca[1].py) < D) {
              triadas.push({ ns: [a, cerca[0], cerca[1]], t0: ahora });
              break;
            }
          }
        }
        triadas = triadas.filter(t => ahora - t.t0 < 4200);
        const brillan = new Map();
        for (const t of triadas) {
          const e = envolvente(ahora - t.t0), [a, b, c] = t.ns, f = Math.min(a.f, b.f, c.f);
          ctx.beginPath(); ctx.moveTo(a.px, a.py); ctx.lineTo(b.px, b.py); ctx.lineTo(c.px, c.py); ctx.closePath();
          ctx.fillStyle = 'rgba(' + CELESTE + ',' + (0.12 * red * e * f).toFixed(3) + ')';
          ctx.fill();
          ctx.lineWidth = 1.2;
          ctx.strokeStyle = 'rgba(' + STEEL + ',' + (0.3 * red * e * f).toFixed(3) + ')';
          ctx.stroke();
          t.ns.forEach(n => brillan.set(n, Math.max(brillan.get(n) || 0, e)));
        }
        // Puntos
        for (const nd of nodos) {
          const e = brillan.get(nd) || 0;
          const base = nd.celeste ? 0.55 : 0.35;
          ctx.fillStyle = 'rgba(' + (nd.celeste || e ? CELESTE : STEEL) + ',' + Math.min(1, (base + 0.4 * e) * red * nd.f).toFixed(3) + ')';
          ctx.beginPath(); ctx.arc(nd.px, nd.py, nd.r * (1 + 0.6 * e), 0, TAU); ctx.fill();
        }
        // Donde hay texto, nada
        ctx.globalCompositeOperation = 'destination-out';
        ctx.fillStyle = '#000';
        let lo = 0, hi = texto.length;
        while (lo < hi) { const m = (lo + hi) >> 1; if (texto[m].y < sy - 120) lo = m + 1; else hi = m; }
        for (let i = lo; i < texto.length && texto[i].y < sy + H; i++) {
          const q = texto[i];
          if (q.y + q.h < sy) continue;
          ctx.fillRect(q.x - sx, q.y - sy, q.w, q.h);
        }
        ctx.globalCompositeOperation = 'source-over';
      }
      const pedir = alcance.requestAnimationFrame ? f => alcance.requestAnimationFrame(f) : f => setTimeout(f, 1000 / fps);
      function cuadro() {
        pedir(cuadro);
        if (pausa || !ctx) return;
        const ahora = reloj();
        if (ahora - ultimo < 1000 / fps - 2) return;
        const dt = Math.min(0.1, (ahora - (ultimo || ahora)) / 1000);
        ultimo = ahora;
        dibujar(ahora, dt);
      }
      alcance.onmessage = e => {
        const m = e.data;
        if (m.tipo === 'inicio') {
          ctx = m.lienzo.getContext('2d');
          if (!ctx) return;
          red = m.red; cero = m.cero; fps = m.fps; sx = m.sx; sy = m.sy;
          proxTriada = reloj() + 4000;
          dimensionar(m.W, m.H, m.dpr);
          pedir(cuadro);
        } else if (m.tipo === 'tamano') { if (ctx) dimensionar(m.W, m.H, m.dpr); }
        else if (m.tipo === 'scroll') { sx = m.sx; sy = m.sy; }
        else if (m.tipo === 'mapa') { texto = m.texto; bandas = m.bandas; }
        else if (m.tipo === 'puntero') puntero = m.p;
        else if (m.tipo === 'pausa') pausa = m.si;
      };
    }

    // Hilo principal: arranca el dibujante en un worker y le manda lo que necesita. Sin worker u
    // OffscreenCanvas (navegadores antiguos, como iOS anterior a 16.4) no hay red: dibujarla desde
    // el hilo principal costaba más de lo que aporta (medido: +23 puntos de ocupación aun a 15
    // cuadros por segundo). Lo demás del fondo sigue igual.
    const lienzo = document.createElement('canvas');
    lienzo.className = 'hai-respira__red';
    if (!lienzo.transferControlToOffscreen || !window.Worker || !window.Blob || !window.URL) return;
    cielo.appendChild(lienzo);
    const medidas = () => {
      const r = cielo.getBoundingClientRect();
      return { W: Math.round(r.width), H: Math.round(r.height), dpr: Math.min(window.devicePixelRatio || 1, 2) };
    };
    let trabajador;
    try {
      const fuente = URL.createObjectURL(new Blob(['(' + dibujante.toString() + ')(self);'], { type: 'text/javascript' }));
      trabajador = new Worker(fuente);
      const fuera = lienzo.transferControlToOffscreen();
      trabajador.postMessage({ tipo: 'inicio', lienzo: fuera, red: nivel.red, cero: performance.timeOrigin + inicio, fps: 30, sx, sy, ...medidas() }, [fuera]);
    } catch (e) {
      lienzo.remove();
      return;
    }
    let vivo = true;
    const enviar = m => { if (vivo) trabajador.postMessage(m); };
    trabajador.addEventListener('error', () => { vivo = false; trabajador.terminate(); lienzo.remove(); });

    // Desplazamiento, tamaño, mouse y pausas (cajones, modales, pestaña oculta)
    window.addEventListener('scroll', () => {
      enviar({ tipo: 'scroll', sx, sy });
      if (Math.abs(sy - mapa.y) > window.innerHeight * 0.5) pedirMedida();
    }, { passive: true });
    let tamano;
    window.addEventListener('resize', () => {
      clearTimeout(tamano);
      tamano = setTimeout(() => { enviar({ tipo: 'tamano', ...medidas() }); pedirMedida(); }, 150);
    });
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      window.addEventListener('pointermove', e => enviar({ tipo: 'puntero', p: { x: e.clientX, y: e.clientY } }), { passive: true });
      document.documentElement.addEventListener('mouseleave', () => enviar({ tipo: 'puntero', p: null }));
    }
    let pausado = false;
    const revisarPausa = () => {
      const si = document.hidden || cajonAbierto();
      if (si !== pausado) { pausado = si; enviar({ tipo: 'pausa', si }); }
    };
    document.addEventListener('visibilitychange', revisarPausa);
    setInterval(() => { if (vivo) revisarPausa(); }, 1000);

    // Lo que hay que respetar: líneas de texto y franjas translúcidas, en coordenadas de la página.
    // Se mide una pantalla arriba y dos abajo; se vuelve a medir al desplazar media pantalla o cada
    // 5 s (carruseles, pestañas y secciones que cargan tarde), cuando el navegador está libre.
    const mapa = { y: -1e9, pendiente: false };
    const OMITIR = 'script, style, noscript, template, ' + TAPA;
    function medir() {
      mapa.pendiente = false;
      if (!vivo) return;
      const x0 = window.scrollX, y0 = window.scrollY, alto = window.innerHeight;
      const desde = y0 - alto, hasta = y0 + 2 * alto;
      const texto = [];
      const rango = document.createRange();
      hogar.querySelectorAll('.shopify-section').forEach(sec => {
        if (/header|announcement/.test(sec.id)) return;
        const r = sec.getBoundingClientRect();
        if (!r.height || r.bottom + y0 < desde || r.top + y0 > hasta) return;
        const paseo = document.createTreeWalker(sec, NodeFilter.SHOW_TEXT);
        for (let n = paseo.nextNode(); n; n = paseo.nextNode()) {
          if (!n.textContent.trim()) continue;
          const padre = n.parentElement;
          if (!padre || padre.closest(OMITIR)) continue;
          rango.selectNodeContents(n);
          for (const q of rango.getClientRects()) {
            if (q.width < 1 || q.height < 1) continue;
            const top = q.top + y0;
            if (top + q.height < desde || top > hasta) continue;
            texto.push({ x: q.left + x0 - 8, y: top - 6, w: q.width + 16, h: q.height + 12 });
          }
        }
      });
      texto.sort((a, b) => a.y - b.y);
      const franjas = [...bandas].filter(([el]) => el.isConnected).map(([el, perfil]) => {
        const r = el.getBoundingClientRect();
        return { x: r.left + x0, y: r.top + y0, w: r.width, h: r.height, a: Array.from({ length: 11 }, (_, i) => perfil(i / 10)) };
      });
      mapa.y = y0;
      enviar({ tipo: 'mapa', texto, bandas: franjas });
    }
    const idle = window.requestIdleCallback ? f => requestIdleCallback(f, { timeout: 400 }) : f => setTimeout(f, 60);
    function pedirMedida() {
      if (mapa.pendiente) return;
      mapa.pendiente = true;
      idle(medir);
    }
    setInterval(() => { if (!pausado) pedirMedida(); }, 5000);
    aclarado.then(pedirMedida);
  }
})();
